import { format } from "date-fns";

import { convertCentsToEuros } from "./convertCentsToEuros.ts";

/**
 * Date Formatting
 */
const dateFormatterMap = {
    short: new Intl.DateTimeFormat("nl-NL", {
        dateStyle: "short",
    }),
    medium: new Intl.DateTimeFormat("nl-NL", {
        dateStyle: "medium",
    }),
    long: new Intl.DateTimeFormat("nl-NL", {
        dateStyle: "long",
    }),
};

export function formatDate(date: Date, format: keyof typeof dateFormatterMap = "short"): string {
    return dateFormatterMap[format].format(date);
}

export function dateMonthFormatter(date: Date): string {
    return format(date, "MM-yyyy");
}

export function dateForUrlFormatter(date: Date): string {
    return format(date, "yyyy-MM-dd");
}

/**
 * Date & Time Formatting
 */
const dateTimeFormatterMap = {
    short: new Intl.DateTimeFormat("nl-NL", {
        dateStyle: "short",
        timeStyle: "short",
    }),
    long: new Intl.DateTimeFormat("nl-NL", {
        dateStyle: "long",
        timeStyle: "short",
    }),
};

export function formatDateTime(date: Date, format: keyof typeof dateTimeFormatterMap = "short"): string {
    return dateTimeFormatterMap[format].format(date);
}

/**
 * Time Formatting
 */
const TIME_FORMATTER_SHORT = new Intl.DateTimeFormat("nl-NL", {
    timeStyle: "short",
});

export function formatTime(date: Date): string {
    return TIME_FORMATTER_SHORT.format(date);
}

export function formatTimeRange(start: Date, end: Date): string {
    return `${TIME_FORMATTER_SHORT.format(start)} — ${TIME_FORMATTER_SHORT.format(end)}`;
}

export function formatSeconds(seconds?: number | null): string {
    const totalMinutes = Math.floor((seconds ?? 0) / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours === 0) {
        return `${minutes}m`;
    }

    return `${hours}h ${minutes}m`;
}

export function formatKilometers(distanceInMeters: number): string {
    const kilometers = (distanceInMeters ?? 0) / 1000;

    return kilometers.toFixed(2);
}

/**
 * Money Formatting
 */
const MONEY_FORMATTER = new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
});

export function formatCents(amountInCents: number): string {
    return MONEY_FORMATTER.format(convertCentsToEuros(amountInCents));
}
